import React, { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { Thumbnail } from '@pkg/components';
import { randomInteger } from '@pkg/utils';

import { memeCollection, memeIds } from './meme-collection';
import { type FloorActivityMemeId } from './types';

import { Interior, Label, StyledMeme, ThumbnailWrapper } from './styles';

export interface MemeProps {
    variant?: FloorActivityMemeId;
    compact?: boolean;
}

export function Meme({ variant, compact = false }: MemeProps) {
    const { t: translate } = useTranslation('floorgame');

    const { labelKey, image } = useMemo(() => (variant ? memeCollection[variant] : getRandomMeme()), [variant]);

    return (
        <StyledMeme $compact={compact}>
            <Interior>
                <ThumbnailWrapper>
                    <Thumbnail imageUrl={image} />
                </ThumbnailWrapper>

                <Label>{translate(labelKey)}</Label>
            </Interior>
        </StyledMeme>
    );
}

function getRandomMeme() {
    const max = Object.keys(memeCollection).length - 1;
    const index = randomInteger(0, max);
    const key = memeIds[index];

    return memeCollection[key];
}
